
import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { GlobalService } from '../../services/global/global.service';
import { Advice, AuditTrail } from 'app/interfaces/global.interface';
import { DBContextFirebaseService } from '../db-context/db-context.firebase.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Globals } from 'app/globals';
import * as firebase from 'firebase'
import { User } from 'app/core/user';
import { AuthService } from 'app/core/auth.service';

// services

// tslint:disable-next-line:max-line-length

@Injectable()
export class GlobalFirebaseService implements GlobalService {

    constructor(
        private afDB: AngularFirestore,
        private gb: Globals,
        private authService: AuthService,
        private dBContextFirebaseService: DBContextFirebaseService,
        public http: HttpClient

    ) { }
    // --- advice moet hier kom.

    //  Advice
    async setAdvice(data: Advice): Promise<Advice> {
        const collection = this.afDB.collection('advice')
        return this.dBContextFirebaseService.set(data, collection)
    }

    async getAdvice(): Promise<Advice[]> {
        const collection = this.afDB.firestore.collection('advice')
        return await this.dBContextFirebaseService.getCollection(collection)
    }

    async setAllUsers(users: User[]): Promise<User> {
        const collection = this.afDB.collection('allUsers')
        return this.dBContextFirebaseService.set(users, collection)
    }

    async getAllUsers(): Promise<User[]> {
        const collection = this.afDB.firestore.collection('allUsers')
        return await this.dBContextFirebaseService.getCollection(collection)
    }

    async getMemberAdvice(uid: string): Promise<Advice[]> {
        const collection = this.afDB.firestore.collection('advice')
            .where('memberUid', '==', uid).orderBy('dateUpdated', 'asc')
        return await this.dBContextFirebaseService.getCollection(collection)
    }

    async sendEmail(emailTo: string, message: string, subject: string, from: string) {

        const token = await this.authService.getUserAuthToken()

        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            })
        };

        const getURL = environment.functionsUrl + '/general/send-email'

        this.http.post(getURL, {
            'to': emailTo,
            'text': message,
            'subject': subject,
            'from': from
        }, httpOptions).toPromise().then(result => {
            console.log(result)
        }).catch(error => {
            console.log(error)
        })

    }

    async setAuditTrail(data: AuditTrail) {
        const loggedInUser = this.gb.getLoggedInUser()

        data.userName = loggedInUser.firstName
        data.userLastName = loggedInUser.lastName
        data.userUid = loggedInUser.uid
        data.dateUpdated = firebase.firestore.Timestamp.now()
        const collection = this.afDB.collection('auditTrail')
        this.dBContextFirebaseService.set(data, collection)
    }
}
